<template>
	<div>
		<modal ref="desativar_usuario">
			<div class="row">
				<div class="col-xs-12">
					<i class="fa fa-trash-o"></i> {{ _traducao('global', 'desativarUsuario').toUpperCase() }}
					<hr />
				</div>
			</div>

			<div class="row">
				<div class="col-xs-12 text-center">
					<h2>{{ _traducao('global', 'desejaDesativarEsseUsuario').toUpperCase() }}</h2>
					<h3 class="text-danger" style="margin: 20px 0 20px 0; font-weight: bolder">{{ form.nome.toUpperCase() }}</h3>
					<hr />
				</div>
			</div>

			<div class="row">
				<div class="col-xs-12">
					<button type="button" @click="$refs.desativar_usuario.modalHide()" class="btn btn-default pull-left">
						<i class="fa fa-times fa-fw"></i>{{ _traducao('global', 'cancelar').toUpperCase() }}
					</button>

					<button type="button" @click="desativarUsuario()" class="btn btn-danger pull-right">
						<i class="fa fa-trash-o fa-fw"></i> {{ _traducao('global', 'desativar').toUpperCase() }}
					</button>
				</div>
			</div>
		</modal>
	</div>
</template>
<script>
export default {
	props: ['form'],

	methods: {
		carregaModal() {
			this.$nextTick(() => {
				this.$refs.desativar_usuario.modalShow(60)
			})
		},
		desativarUsuario() {
			bus.$emit('load-in', {text: 'Desativando Usuário'})

			this._httpGet('/Usuario/desativa/' + this.form.id, (retorno) => {
				bus.$emit('load-out')

				if (retorno._request) {
					if (retorno._status) {
						this.$refs.desativar_usuario.modalHide()
						this.$emit('excluido', retorno.lista[0])
					} else {
						bus.$emit('exibir-notificacao', {type: 'danger', text: 'Não foi possível desativar esse usuário.'})
					}
				}
			})
		}
	}
}
</script>